module.exports = __webpack_public_path__ + "img/icon_05.c045d79.png";